import { call, put, select } from "redux-saga/effects";
import { request, addQueryParams } from "@nested/utils";
import { getConfig } from "@nested/config";

export const AB_TEST_SUCCESS = "app/hocs/abTest/AB_TEST_SUCCESS";
export const AB_TEST_ERROR = "app/hocs/abTest/AB_TEST_ERROR";
export const AB_TEST_USER_ID = "app/hocs/abTest/AB_TEST_USER_ID";
export const AB_TEST_FETCHING = "app/hocs/abTest/AB_TEST_FETCHING";

const { BANDIERA_API } = getConfig();

const initialState = () => ({
  abTestUserId: null,
  featureFlags: {},
  splitTestGroups: [],
  fetching: false,
  fetched: false,
});

function startsWithDatePattern(key) {
  return /\d{8}_/.test(key);
}

export function serializeFlags(flags) {
  return Object.keys(flags).reduce((array, key) => {
    if (!startsWithDatePattern(key)) return array;
    return array.concat(`${key}_${flags[key] === false ? "A" : "B"}`);
  }, []);
}

export const getABTestCookie = (state) => state.abTest.abTestUserId;
export const getFetched = (state) => state.abTest.fetched;
export const getFetching = (state) => state.abTest.fetching;

export function reducer(state = initialState(), action) {
  switch (action.type) {
    case AB_TEST_USER_ID:
      return {
        ...state,
        abTestUserId: action.payload.userId,
      };
    case AB_TEST_FETCHING:
      return { ...state, fetching: true };
    case AB_TEST_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: true,
        featureFlags: action.payload.json.response.nested,
        splitTestGroups: serializeFlags(action.payload.json.response.nested),
      };
    case AB_TEST_ERROR:
      return {
        ...state,
        fetching: false,
      };
    default:
      return state;
  }
}

export const abTestUserId = (userId) => ({
  type: AB_TEST_USER_ID,
  payload: { userId },
});

export const abTestFetchingAction = () => ({
  type: AB_TEST_FETCHING,
});

export const abTestSuccessAction = (json) => ({
  type: AB_TEST_SUCCESS,
  payload: { json },
});

export const abTestErrorAction = (error) => ({
  type: AB_TEST_ERROR,
  payload: { error },
});

export function* fetchFeatureFlags() {
  const currentABTestUserId = yield select(getABTestCookie);
  const fetched = yield select(getFetched);
  const fetching = yield select(getFetching);

  if (!(fetched || fetching)) {
    try {
      yield put(abTestFetchingAction());
      const bandieraUrl = addQueryParams(`${BANDIERA_API}/all`, {
        user_group: "anonymous",
        user_id: currentABTestUserId,
      });
      const jsonResponse = yield call(request, bandieraUrl);
      yield put(abTestSuccessAction(jsonResponse));
    } catch (err) {
      yield put(abTestErrorAction(err));
    }
  }
}
